import { NOTIFICATION_BAR_STATES } from 'constants/AppConstants';
import * as types from 'constants/ActionTypes';

const initialState = {
  showNotification: false,
  title: 'Notification Bar title',
  footer: '',
  status: NOTIFICATION_BAR_STATES.IDLE,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.NOTIFICATION_START:
      return {
        ...state, showNotification: true, status: NOTIFICATION_BAR_STATES.PROGRESS, title: action.title, footer: action.footer,
      };
    case types.NOTIFICATION_SUCCESS:
      return {
        ...state, showNotification: true, status: NOTIFICATION_BAR_STATES.SUCCESS, title: action.title, footer: action.footer,
      };
    case types.NOTIFICATION_ERROR:
      return {
        ...state, showNotification: true, status: NOTIFICATION_BAR_STATES.ERROR, title: action.title, footer: action.footer,
      };
    case types.NOTIFICATION_CLOSE: {
      if (state.status === NOTIFICATION_BAR_STATES.PROGRESS) {
        return {
          ...state, status: NOTIFICATION_BAR_STATES.CLOSE,
        };
      }
      if (state.status === NOTIFICATION_BAR_STATES.ERROR) {
        return {
          ...state, showNotification: false, status: NOTIFICATION_BAR_STATES.CLOSE,
        };
      }
      return {
        ...state, showNotification: false, status: NOTIFICATION_BAR_STATES.IDLE,
      };
    }
    default:
      return state;
  }
};
